import { Link } from 'react-router';
import { RotateCcw } from 'lucide-react';

export function ServerErrorPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 px-6 py-16 text-center dark:bg-gray-900">
      <p className="text-brand-500 text-sm font-semibold tracking-widest uppercase">
        500 error
      </p>
      <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl dark:text-white">
        Something went wrong
      </h1>
      <p className="max-w-md text-base text-gray-500 dark:text-gray-400">
        The server ran into an unexpected issue. Our team has been notified.
        You can try again in a moment.
      </p>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bg-brand-500 hover:bg-brand-600 inline-flex items-center gap-2 rounded-md px-4 py-2.5 text-sm font-medium text-white shadow-sm transition"
        >
          <RotateCcw className="h-4 w-4" aria-hidden="true" />
          Try again
        </button>
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-sm transition hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
